// src/components/products/ui/Tooltip.jsx

import React, { useState } from 'react';

const Tooltip = ({ content, children }) => {
  const [show, setShow] = useState(false);
  
  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="cursor-help"
      >
        {children}
      </div>
      {show && (
        <div className="absolute z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg -top-2 left-6 w-64 transform -translate-y-full">
          <div className="absolute w-2 h-2 bg-gray-900 transform rotate-45 -bottom-1 left-3"></div>
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;